import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import { exhibitorsApi } from '@/shared/api/exhibitorsApi';
import type {
  CreateDelegateRequest,
  UpdateDelegateRequest,
  CreateEventRequest,
  CreateExhibitorRequest,
  CreateUserRequest,
  DelegateDto,
  EventDto,
  ExhibitorDto,
  LeadDto,
  UpdateEventRequest,
  UpdateExhibitorRequest,
  UpdateUserRequest,
  UpsertLeadNoteRequest,
  UserDto
} from '@/shared/types/domain';

export const adminApi = {
  events: {
    list: () => httpClient.get<EventDto[]>(endpoints.events.list),
    getById: (id: string) => httpClient.get<EventDto>(endpoints.events.byId(id)),
    create: (data: CreateEventRequest) => httpClient.post<EventDto>(endpoints.events.create, data),
    update: (id: string, data: UpdateEventRequest) => httpClient.put<EventDto>(endpoints.events.update(id), data)
  },

  exhibitors: {
    listByEvent: (eventId: string) => httpClient.get<ExhibitorDto[]>(endpoints.exhibitors.byEvent(eventId)),
    getById: exhibitorsApi.getById,
    create: (data: CreateExhibitorRequest) => httpClient.post<ExhibitorDto>(endpoints.exhibitors.create, data),
    update: (id: string, data: UpdateExhibitorRequest) =>
      httpClient.put<ExhibitorDto>(endpoints.exhibitors.update(id), data),
    delete: (id: string) => httpClient.delete<void>(endpoints.exhibitors.delete(id))
  },

  delegates: {
    listByEvent: (eventId: string) => httpClient.get<DelegateDto[]>(endpoints.delegates.byEvent(eventId)),
    create: (data: CreateDelegateRequest) => httpClient.post<DelegateDto>(endpoints.delegates.create, data),
    update: (id: string, data: UpdateDelegateRequest) => httpClient.put<DelegateDto>(endpoints.delegates.update(id), data),
    exportCsv: (eventId: string) => httpClient.downloadFile(endpoints.delegates.exportCsv(eventId)),
    exportXlsx: (eventId: string) => httpClient.downloadFile(endpoints.delegates.exportXlsx(eventId))
  },

  users: {
    listByEvent: (eventId: string) => httpClient.get<UserDto[]>(endpoints.users.byEvent(eventId)),
    listByExhibitor: (exhibitorId: string) => httpClient.get<UserDto[]>(endpoints.users.byExhibitor(exhibitorId)),
    create: (data: CreateUserRequest) => httpClient.post<UserDto>(endpoints.users.create, data),
    update: (id: string, data: UpdateUserRequest) => httpClient.put<UserDto>(endpoints.users.update(id), data),
    delete: (id: string) => httpClient.delete<void>(endpoints.users.delete(id)),
    resetPassword: (id: string, newPassword: string) =>
      httpClient.post<void>(endpoints.users.resetPassword(id), { newPassword })
  },

  leads: {
    listByExhibitor: (exhibitorId: string) => httpClient.get<LeadDto[]>(endpoints.leads.byExhibitor(exhibitorId)),
    upsertNotes: (scanId: string, data: UpsertLeadNoteRequest) =>
      httpClient.put<LeadDto>(endpoints.leads.upsertNotes(scanId), data),
    delete: (scanId: string) => httpClient.delete<void>(endpoints.leads.delete(scanId)),
    exportCsv: (exhibitorId: string) => httpClient.downloadFile(endpoints.leads.exportTeamCsv(exhibitorId)),
    exportXlsx: (exhibitorId: string) => httpClient.downloadFile(endpoints.leads.exportTeamXlsx(exhibitorId))
  }
};